
/**
 * Utility functions for debugging environment variables and configuration
 */
import { getGoogleMapsApiKey, getCurrentDomain } from './googleMapsKey';

export const diagnoseApiKeys = () => {
  // Get both the raw key and our processed key
  const rawGoogleMapsApiKey = import.meta?.env?.VITE_GOOGLE_MAPS_API_KEY;
  const processedGoogleMapsApiKey = getGoogleMapsApiKey();
  const currentDomain = getCurrentDomain();
  
  console.group('Environment Variable Diagnostics');
  console.log('Raw Google Maps API Key Available:', rawGoogleMapsApiKey ? 'Yes' : 'No');
  console.log('Raw Google Maps API Key Length:', rawGoogleMapsApiKey?.length || 0);
  console.log('Raw Google Maps API Key Type:', typeof rawGoogleMapsApiKey);
  
  console.log('Processed Google Maps API Key Available:', processedGoogleMapsApiKey ? 'Yes' : 'No');
  console.log('Processed Google Maps API Key Length:', processedGoogleMapsApiKey?.length || 0);
  
  // Check if it appears to be a valid Google Maps API key format
  const isRawFormatValid = typeof rawGoogleMapsApiKey === 'string' && 
    rawGoogleMapsApiKey.includes('AIza');
    
  const isProcessedFormatValid = typeof processedGoogleMapsApiKey === 'string' && 
    processedGoogleMapsApiKey.startsWith('AIza') && 
    processedGoogleMapsApiKey.length > 30;
    
  console.log('Raw Key Format Appears Valid:', isRawFormatValid ? 'Yes' : 'No');
  console.log('Processed Key Format Appears Valid:', isProcessedFormatValid ? 'Yes' : 'No');
  console.log('Current Domain:', currentDomain);
  
  // Log the first few characters of the key for debugging (safely)
  if (rawGoogleMapsApiKey && typeof rawGoogleMapsApiKey === 'string' && rawGoogleMapsApiKey.length > 8) {
    console.log('Raw Key Preview:', `${rawGoogleMapsApiKey.substring(0, 6)}...`);
  }
  
  if (processedGoogleMapsApiKey && processedGoogleMapsApiKey.length > 8) {
    console.log('Processed Key Preview:', `${processedGoogleMapsApiKey.substring(0, 6)}...`);
  }
  
  console.groupEnd();
  
  return {
    googleMapsApiKey: {
      raw: {
        present: !!rawGoogleMapsApiKey,
        length: typeof rawGoogleMapsApiKey === 'string' ? rawGoogleMapsApiKey.length : 0,
        type: typeof rawGoogleMapsApiKey,
        validFormat: isRawFormatValid,
        keyPreview: typeof rawGoogleMapsApiKey === 'string' && rawGoogleMapsApiKey.length > 8 ? 
          `${rawGoogleMapsApiKey.substring(0, 6)}...` : null
      },
      processed: {
        present: !!processedGoogleMapsApiKey,
        length: processedGoogleMapsApiKey.length,
        validFormat: isProcessedFormatValid,
        keyPreview: processedGoogleMapsApiKey && processedGoogleMapsApiKey.length > 8 ? 
          `${processedGoogleMapsApiKey.substring(0, 6)}...` : null
      },
      domain: currentDomain
    }
  };
};

export const runDiagnostics = () => {
  console.log('Running environment diagnostics...');
  const result = {
    apiKeys: diagnoseApiKeys(),
    timestamp: new Date().toISOString(),
    environment: {
      isDevelopment: import.meta?.env?.DEV,
      mode: import.meta?.env?.MODE || 'unknown',
      baseUrl: import.meta?.env?.BASE_URL || 'unknown',
    }
  };
  
  console.log('Diagnostics result:', result);
  return result;
};
